import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useLanguage } from "@/i18n/LanguageContext";

interface ContactData {
  address: string;
  phone: string;
  email: string;
  opening_hours: string;
  instagram_url: string;
  facebook_url: string;
  maps_url: string;
  whatsapp_url: string;
  youtube_url: string;
  mobile_phone: string;
}

export const useContactInfo = () => {
  const { language } = useLanguage();
  const [info, setInfo] = useState<ContactData | null>(null);

  useEffect(() => {
    supabase
      .from("contact_info")
      .select("*")
      .limit(1)
      .single()
      .then(({ data }) => {
        if (data) {
          const hoursKey = `opening_hours_${language}` as keyof typeof data;
          setInfo({
            address: data.address,
            phone: data.phone,
            email: data.email,
            opening_hours: (data[hoursKey] as string) || data.opening_hours_de,
            instagram_url: data.instagram_url,
            facebook_url: data.facebook_url,
            maps_url: data.maps_url,
            whatsapp_url: (data as any).whatsapp_url || '',
            youtube_url: (data as any).youtube_url || '',
            mobile_phone: (data as any).mobile_phone || '',
          });
        }
      });
  }, [language]);

  return info;
};
